var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "markdamagemps"
  }, [_c('b-card', [_c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "#3ba9f3",
      "size": "60",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 mb-1"
  }, [_c('div', {
    staticClass: "card-header -filter_main"
  }, [_c('label', [_vm._v("Add/Edit Cargo Shipment Damage Mark ")]), _vm._v(" "), _c('div', {
    staticClass: "card-actions"
  }, [_c('a', {
    attrs: {
      "title": "Back to Damage MPS List"
    },
    on: {
      "click": _vm.damagempslist
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left",
    staticStyle: {
      "font-size": "18px"
    },
    attrs: {
      "style": "font-size:18px"
    }
  })])])])])]), _vm._v(" "), _c('div', [_c('b-card', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmitSearch($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("MPS Number"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-tag' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mpsnumber),
      expression: "mpsnumber"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "disabled": _vm.mpsdisableflag == true,
      "name": "MPS Number",
      "id": "MPS Number",
      "placeholder": "Enter MPS Number"
    },
    domProps: {
      "value": (_vm.mpsnumber)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.searchMPS()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mpsnumber = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.mpsnumberErr))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-input-group', [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button",
      "title": "Search"
    },
    on: {
      "click": function($event) {
        _vm.searchMPS()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Go")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Current Region Name")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-map-marker' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.regionname),
      expression: "regionname"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "disabled": _vm.disableflag == true,
      "name": "Region Name",
      "id": "Region Name",
      "placeholder": "Region Name"
    },
    domProps: {
      "value": (_vm.regionname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.regionname = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.regionnameErr))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Origin Hub/SVC Name")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-gear' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.originname),
      expression: "originname"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "disabled": _vm.disableflag == true,
      "name": "Origin Name",
      "id": "Origin Name",
      "placeholder": "Origin Name"
    },
    domProps: {
      "value": (_vm.originname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.originname = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.originnameErr))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Current Hub/SVC Name")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-bank' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currenthubname),
      expression: "currenthubname"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "disabled": _vm.disableflag == true,
      "name": "Current Hub Name",
      "id": "Current Hub Name",
      "placeholder": "Current Hub Name"
    },
    domProps: {
      "value": (_vm.currenthubname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.currenthubname = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.currenthubnameErr))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Mark Damage Zone"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-wifi' style='font-size: 12px'></i>"
    }
  }, [_c('treeselect', {
    attrs: {
      "multiple": false,
      "max-height": 200,
      "clearable": false,
      "options": _vm.markdamagezonelist,
      "placeholder": "Select Damage Zone",
      "id": "damagzone",
      "append-to-body": true,
      "name": "damagezone"
    },
    on: {
      "select": _vm.selectMarkDamageZone
    },
    model: {
      value: (_vm.damagezone),
      callback: function($$v) {
        _vm.damagezone = $$v
      },
      expression: "damagezone"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.damagezoneErr))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Mark Damage Hub/SVC Name")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-bank' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.markdamagehubname),
      expression: "markdamagehubname"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "disabled": _vm.disableflag == true,
      "name": "Mark Damage Hub Name",
      "id": "Mark Damage Hub Name",
      "placeholder": "Mark Damage Hub Name"
    },
    domProps: {
      "value": (_vm.markdamagehubname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.markdamagehubname = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.markdamagehubnameErr))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Mark Condition"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-tasks' style='font-size: 12px'></i>"
    }
  }, [_c('treeselect', {
    attrs: {
      "multiple": false,
      "max-height": 200,
      "clearable": false,
      "options": _vm.MarkConditionList,
      "placeholder": "Select Damage Condition",
      "id": "markcondition",
      "append-to-body": true,
      "name": "markcondition"
    },
    on: {
      "select": _vm.selectMarkCondition
    },
    model: {
      value: (_vm.markcondition),
      callback: function($$v) {
        _vm.markcondition = $$v
      },
      expression: "markcondition"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.markconditionErr))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Upload Images"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "file-upload"
  }, [_c('label', {
    attrs: {
      "for": "damagedoc"
    }
  }, [_c('i', {
    staticClass: "fa fa-upload",
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "title": "Upload Document",
      "aria-hidden": "true"
    }
  }), _vm._v("  \n                                  ")]), _vm._v(" "), _c('input', {
    ref: "file",
    attrs: {
      "id": "damagedoc",
      "name": "damagedoc",
      "multiple": "multiple",
      "accept": ".jpeg,.jpg,.png",
      "type": "file"
    },
    on: {
      "change": _vm.UploadDocument
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "clientnote "
  }, [_c('i', {
    staticClass: "fa fa-exclamation-circle"
  }), _vm._v(" Allowed image file types: gif, jpg, jpeg, png (Maximum size: 6000 KB)\n                            ")]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.damagedocErr))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [(_vm.imagearray.length > 0) ? _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', {
    staticClass: "th"
  }, [_c('tr', {
    staticClass: "text-primary",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('th', [_vm._v("Images Uploaded")]), _vm._v(" "), _c('th', [_vm._v("Remove Images")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.imagearray), function(data, index) {
    return _c('tr', {
      staticClass: "text-primary",
      staticStyle: {
        "width": "100%"
      }
    }, [_c('td', {
      staticClass: "text-center",
      attrs: {
        "width": "50%"
      }
    }, [_c('img', {
      staticStyle: {
        "width": "35px",
        "height": "35px",
        "cursor": "pointer"
      },
      attrs: {
        "src": data,
        "alt": "NO Image"
      },
      on: {
        "click": function($event) {
          _vm.openImage(data)
        }
      }
    })]), _c('td', {
      staticClass: "text-center",
      attrs: {
        "width": "50%"
      }
    }, [(data) ? _c('i', {
      staticClass: "fa fa-remove",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "aria-hidden": "true",
        "title": "Remove Document"
      },
      on: {
        "click": function($event) {
          _vm.selectRemove(data, index)
        }
      }
    }) : _vm._e()])])
  }))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Description"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-address-card' style='font-size: 12px'></i>"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.description),
      expression: "description"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "placeholder": "Description",
      "name": "description",
      "id": "description"
    },
    domProps: {
      "value": (_vm.description)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.description = $event.target.value
      }, function($event) {
        _vm.decriptionfunction(_vm.description)
      }]
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.descriptionErr))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-9"
  }, [_c('label')]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.save
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Save")]), _vm._v("   \n                            "), _c('button', {
    staticClass: "-btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.reset
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Reset")])])])])])], 1), _vm._v(" "), _c('section', [_c('img', {
    staticStyle: {
      "width": "100%",
      "max-width": "300px"
    },
    attrs: {
      "id": "myImg",
      "id": 'imgid' + _vm.damageimage
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal",
    staticStyle: {
      "background-color": "rgb(0,0,0)"
    },
    attrs: {
      "id": 'myModalImg' + _vm.damageimage
    }
  }, [_c('span', {
    staticClass: "closemodel",
    staticStyle: {
      "cursor": "pointer",
      "color": "#f1f1f1",
      "float": "right",
      "font-size": "40px",
      "position": "relative",
      "top": "0px",
      "right": "20px",
      "font-weight": "bold",
      "transition": "0.3s",
      "z-index": "9999"
    },
    attrs: {
      "title": "Close Image"
    },
    on: {
      "click": function($event) {
        _vm.closemodal('myModalImg' + _vm.damageimage)
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "auto",
      "display": "block",
      "width": "80%",
      "max-width": "700px",
      "text-align": "center",
      "color": "rgb(204, 204, 204)",
      "padding": "0px 0px",
      "height": "35px",
      "font-size": "20px!important"
    },
    attrs: {
      "id": 'captionImg' + _vm.damagecaption
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "modal-content1",
    staticStyle: {
      "width": "70%",
      "margin": "auto",
      "display": "block",
      "max-width": "70%"
    },
    attrs: {
      "id": 'img' + _vm.damageimage,
      "src": _vm.damageimage
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "auto",
      "display": "block",
      "width": "80%",
      "max-width": "700px",
      "text-align": "center",
      "color": "#ccc",
      "padding": "10px 0",
      "height": "150px"
    }
  })])])], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e114c49","hasScoped":true}!./src/modules/firstAndLastmilemanagement/views/DamageMPS/markdamageMPS/markdamageMPS.component.html
// module id = 1904
// module chunks = 3